<!-- Il widget viene renderizzato in un overlay CDK dedicato (vedi ngAfterViewInit),
     così resta sempre sopra le dialog, anche quelle annidate -->
<ng-template #widgetTpl>
  <zcs-chat-widget
    #widget
    [opened]="false"
    [title]="'Follia'"
    [subtitle]="'Sostenibile.cloud'"
    [context]="context"
    [parameters]="parameters"
    [host]="HOST"
    [placeholder]="'Poni una domanda...'"
    [language]="'it-IT'"
    [continousVoiceInteractionsEnabled]="false"
    [showWidgetVersion]="true"
    [isDebugMode]="isDebugMode"
    (close)="onCloseChat()"
    (open)="onOpenChat()"
    [interactions]="interactions"
    (userEvent)="log('userEvent', $event); onUserEvent($event)"
    (maximize)="log('maximize')"
    (minimize)="log('minimize')"
    (interaction)="log('interaction', $event)"
    [token]="tokenAsyncFunction"
    [sendButtonIconName]="'north'"
    [openChatIconUrl]="folliaIconSvgGradient"
    [showCitationOverlay]="false"
    [showAgentDataInfo]="false"
    [loadFileByPost]="true"
    [isChatHistoryEnabled]="true"
    [showAgentDataInfo]="false"
    #chat
  ></zcs-chat-widget>
</ng-template>
